import BaseComponent from "../../../../../lib/components/BaseComponent";
import LogCard from "./components/LogCard";
import React, {createRef} from "react";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import {ArrowBack} from "@mui/icons-material";

class ChangeLog extends BaseComponent {
    render() {
        return <section className={"w-screen h-screen  bg-cn-bg-img-login bg-cover flex flex-col overflow-hidden"}>
            <div className={'py-10 px-10 lg:px-20 my-10 mx-10 lg:mx-20 bg-cn-color-black rounded-xl overflow-y-scroll'}>

                <h1 className={"text-5xl pb-5 text-cn-color-white"}>Campaigner Changelog</h1>
                <p className={"text-lg text-cn-color-white pb-5 w-full lg:w-3/4 xl:w-2/3"}>Bleiben Sie auf dem Laufenden mit den neuesten Updates und Verbesserungen unserer Plattform.
                    Hier finden Sie eine detaillierte Übersicht aller neuen Funktionen, Bugfixes und Optimierungen.
                </p>
                <div className={'flex flex-col gap-5 mt-10'}>
                    <LogCard version={'2.2.0'} date={'Dezember 2025'}>
                        <li className={'text-cn-color-white'}>Der bisherige Ansatz mit statisch erstellten Versandlisten wurde durch ein Filtersystem ersetzt. Die Filter werden nun erst zum tatsächlichen Versandzeitpunkt ausgeführt, wodurch die Empfängerliste automatisch den aktuellen Kontaktstatus berücksichtigt.</li>
                        <li className={'text-cn-color-white'}>Die Benutzeroberfläche wurde vollständig mit dem MUI-Framework neu aufgebaut. Dadurch profitieren Nutzer von einer moderneren, konsistenteren und performanteren Oberfläche sowie einer verbesserten User Experience.</li>
                    </LogCard>
                    <LogCard version={'2.1.0'} date={'Juli 2023'}>
                        <li className={'text-cn-color-white'}>Komplette Neugestaltung der Benutzeroberfläche und vollständige Neuimplementierung in React.</li>
                        <li className={'text-cn-color-white'}>Modernes, konsistentes und deutlich performanteres UI.</li>
                        <li className={'text-cn-color-white'}>Verbesserte Benutzerführung und optimierte Bedienbarkeit.</li>
                        <li className={'text-cn-color-white'}>Neue technische Basis für kontinuierliche UI-Erweiterungen.</li>
                    </LogCard>
                    <LogCard version={'2.0.2'} date={'März 2022'}>
                        <li className={'text-cn-color-white'}>Einführung der Clone-Funktion für Kampagnen.</li>
                        <li className={'text-cn-color-white'}>Ermöglicht das einfache Kopieren bestehender Campaigns inklusive Einstellungen und Inhalten.</li>
                        <li className={'text-cn-color-white'}>Erleichtert das Wiederverwenden und Anpassen von Kampagnen.</li>
                    </LogCard>
                    <LogCard version={'2.0.1'} date={'September 2021'}>
                        <li className={'text-cn-color-white'}>Einführung der Massenmail-Versandfunktion direkt im Campaigner.</li>
                        <li className={'text-cn-color-white'}>Ermöglicht das Erstellen und Versenden von Massenmails ohne externe Tools.</li>
                        <li className={'text-cn-color-white'}>Erste Grundlage für weitere Verbesserungen im Bereich E-Mail-Kampagnen.</li>
                    </LogCard>
                    <LogCard version={'2.0.0'} date={'September 2019'}>
                        <li className={'text-cn-color-white'}>Veröffentlichung des neuen Campaigner 2 als großes Upgrade von Version 1.0.</li>
                        <li className={'text-cn-color-white'}>Vollständige Modernisierung des technischen Unterbaus für bessere Performance und Stabilität.</li>
                        <li className={'text-cn-color-white'}>Erweiterte und neu strukturierte Kernfunktionen für flexibleres Kampagnen- und Kontaktmanagement.</li>
                        <li className={'text-cn-color-white'}>Fundament für zukünftige Features und UI-Verbesserungen geschaffen.</li>
                    </LogCard>
                    <HorizontalLayout>
                        <a
                          href="/"
                          className="py-3 px-5 rounded border-cn-color-primary hover:border-cn-color-primary-hover bg-cn-color-secondary hover:bg-cn-color-secondary-hover text-white inline-flex items-center gap-2"
                        >
                            <ArrowBack fontSize="small" />
                            zurück
                        </a>
                    </HorizontalLayout>
                </div>
            </div>
        </section>;
    }
}

export default ChangeLog;
